
(() => {
  const root = document.querySelector('[data-shiatsu-shop-root]');
  if (!root) return;

  const toast = document.querySelector('[data-shiatsu-toast]');
  const filtersSection = document.querySelector('[data-shiatsu-filters]');
  const grid = document.querySelector('[data-shiatsu-grid]');
  const rails = document.querySelector('[data-shiatsu-mobile-rails]');
  const cards = Array.from(document.querySelectorAll('[data-shiatsu-card]'));
  const resultCount = document.querySelector('[data-shiatsu-result-count]');
  const loadMoreWrap = document.querySelector('[data-shiatsu-load-more]');
  const loadMoreBtn = document.querySelector('[data-shiatsu-load-more-btn]');
  const searchInput = document.querySelector('[data-shiatsu-search]');
  const filterButtons = Array.from(document.querySelectorAll('[data-filter-type]'));

  let visibleCount = parseInt(root.dataset.initialVisible || '12', 10);
  const step = parseInt(root.dataset.visibleStep || '12', 10);
  const state = { category: 'all', price: 'all', q: '' };

  const money = (n) => n;

  const showToast = (msg) => {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-visible');
    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(() => toast.classList.remove('is-visible'), 2200);
  };

  const updateSticky = () => {
    if (!filtersSection) return;
    const top = filtersSection.getBoundingClientRect().top + window.scrollY;
    filtersSection.classList.toggle('is-sticky', window.scrollY > top - 90);
  };

  const byPrice = (price) => {
    if (state.price === 'under50') return price < 50;
    if (state.price === '50to150') return price >= 50 && price <= 150;
    if (state.price === 'over150') return price > 150;
    return true;
  };

  const matches = (card) => {
    const category = card.dataset.category || 'all';
    const price = parseFloat(card.dataset.price || '0');
    const text = (card.dataset.search || '').toLowerCase();
    const categoryOk = state.category === 'all' || category === state.category;
    const priceOk = byPrice(price);
    const queryOk = !state.q || text.includes(state.q);
    return categoryOk && priceOk && queryOk;
  };

  const buildRails = (filteredCards) => {
    if (!rails) return;
    if (!filteredCards.length) {
      rails.innerHTML = `<div class="shiatsu-empty">Nothing matches — try adjusting the filters.</div>`;
      return;
    }

    const grouped = new Map();
    filteredCards.forEach(card => {
      const key = card.dataset.category || 'all';
      const title = card.dataset.categoryLabel || card.dataset.category || 'Products';
      if (!grouped.has(key)) grouped.set(key, { title, cards: [] });
      grouped.get(key).cards.push(card);
    });

    rails.innerHTML = '';
    grouped.forEach((group, key) => {
      const section = document.createElement('section');
      section.className = 'shiatsu-mobile-rail';

      const head = document.createElement('div');
      head.className = 'shiatsu-mobile-rail__head';
      head.innerHTML = `
        <div>
          <div class="shiatsu-mobile-rail__meta">${group.cards.length} product${group.cards.length === 1 ? '' : 's'}</div>
          <h4 class="shiatsu-mobile-rail__title">${group.title}</h4>
        </div>
        <button type="button" class="shiatsu-pill">${'View all'}</button>
      `;
      head.querySelector('button').addEventListener('click', () => {
        state.category = key;
        syncButtons();
        render();
      });

      const track = document.createElement('div');
      track.className = 'shiatsu-mobile-rail__track';
      group.cards.forEach(card => track.appendChild(card.cloneNode(true)));

      section.appendChild(head);
      section.appendChild(track);
      rails.appendChild(section);
    });

    bindCardButtons(rails);
  };

  const bindCardButtons = (scope = document) => {
    scope.querySelectorAll('[data-shiatsu-add]').forEach(btn => {
      if (btn.dataset.bound === 'true') return;
      btn.dataset.bound = 'true';
      btn.addEventListener('click', async (event) => {
        event.preventDefault();
        const variantId = btn.dataset.variantId;
        if (!variantId || btn.disabled) return;
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
          });
          if (!response.ok) throw new Error('Cart error');
          showToast(btn.dataset.successText || 'Added to bag');
          document.dispatchEvent(new CustomEvent('shiatsu:cart-updated'));
        } catch (error) {
          showToast(btn.dataset.errorText || 'Could not add item right now');
        }
      });
    });

    scope.querySelectorAll('[data-shiatsu-featured-add]').forEach(btn => {
      if (btn.dataset.bound === 'true') return;
      btn.dataset.bound = 'true';
      btn.addEventListener('click', async () => {
        const variantId = btn.dataset.variantId;
        if (!variantId || btn.disabled) return;
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
          });
          if (!response.ok) throw new Error('Cart error');
          showToast(btn.dataset.successText || 'Added to bag');
          document.dispatchEvent(new CustomEvent('shiatsu:cart-updated'));
        } catch (error) {
          showToast(btn.dataset.errorText || 'Could not add item right now');
        }
      });
    });
  };

  const syncButtons = () => {
    filterButtons.forEach(btn => {
      const type = btn.dataset.filterType;
      const value = btn.dataset.filterValue;
      btn.classList.toggle('is-active', state[type] === value);
    });
  };

  const render = () => {
    const filtered = cards.filter(matches);

    if (resultCount) {
      resultCount.textContent = `${filtered.length} product${filtered.length === 1 ? '' : 's'}`;
    }

    cards.forEach(card => card.hidden = true);

    if (!filtered.length) {
      if (grid) {
        grid.innerHTML = `<div class="shiatsu-empty">Nothing matches — try adjusting the filters.</div>`;
      }
      if (loadMoreWrap) loadMoreWrap.hidden = true;
      buildRails([]);
      return;
    }

    if (grid) {
      grid.innerHTML = '';
      filtered.slice(0, visibleCount).forEach(card => {
        card.hidden = false;
        grid.appendChild(card);
      });
      bindCardButtons(grid);
    }

    buildRails(filtered);

    if (loadMoreWrap && loadMoreBtn) {
      const hasMore = filtered.length > visibleCount;
      loadMoreWrap.hidden = !hasMore;
      if (hasMore) {
        loadMoreBtn.textContent = `Load more products (${filtered.length - visibleCount} remaining)`;
      }
    }
  };

  filterButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      state[btn.dataset.filterType] = btn.dataset.filterValue;
      visibleCount = step;
      syncButtons();
      render();
    });
  });

  if (searchInput) {
    searchInput.addEventListener('input', () => {
      state.q = searchInput.value.trim().toLowerCase();
      visibleCount = step;
      render();
    });
  }

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', () => {
      visibleCount += step;
      render();
    });
  }

  bindCardButtons(document);
  syncButtons();
  render();
  updateSticky();
  window.addEventListener('scroll', updateSticky, { passive: true });
  window.addEventListener('resize', updateSticky);
})();
